import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import IdealStudio from "../../../../core/editor/main";
import { Tooltip, OverlayTrigger, Button, Popover, Overlay } from "react-bootstrap";
import {
  UPDATE_BOX,
  selectBox,
  selectNavItem,
  setCorrectAnswer,
  removeInteractiveItem,
  configScore,
  resizeBox,
  updatePluginToolbar,
} from "../../../../common/actions";
import i18n from "i18next";
import { canEditInDirector } from "../../carousel/audio/video-director/edl";
import { isSortableBox, isSortableContainer, isContainedView } from "../../../../common/utils";
import {
  blurCKEditor,
  findBox,
  TEXT_FORMAT_CSS_PROP,
  forceHtmlCssProperty,
  TEXT_TOGGLE_KEYS,
  toggleHtmlCssProperty,
  deriveTextFormatCached,
  stripHtmlCssProperty,
  getBoxContentEl,
  previewCssOnBox,
} from "../../../../common/common_tools";
import { Container } from "@mui/material";
import LipsyncModal from "./LipsyncModal";
import { ImageAnimatorModal } from "../../merlin/ImageAnimatorModal";
import ImageClickActionModal from "./ImageClickActionModal";
import { setPopupDocked } from "../../ai-chat/aiPopupGateway";
import { notifyInsufficientBalance } from "../../../utils/insufficientBalance";
import { normalizeRotation, ROTATION_MIN, ROTATION_MAX } from "../../../utils/rotation";
import { applyAnimationResult } from "../../../utils/applyAnimationResult.es6";
import { isAnimatableImageUrl } from "../../../utils/collectSceneImages.es6";
import { fetchHasReferenceImage } from "../../../../common/server_utils";
import {
  isNonStaticMediaUrl,
  getCachedHasReferenceImage,
  resolveHasReferenceImage,
} from "../../../utils/animationReferenceImage.es6";
import { applyAnswerRemoval } from "./answerReflow";
import AssessmentBoxMenu from "./AssessmentBoxMenu";
import TopActionPill from "./TopActionPill";
import { MOTION_AI_EDIT_EVENT, MOTION_TO_VIDEO_EVENT } from "../../add_image_modal/MotionAiEdit";
import { motionEditTarget } from "../../add_image_modal/sceneVisualService";
import { isEvalPlugin } from "./assessmentMenuConfig";
import "./_textAnimationModal.scss";
import {
  LuPen,
  LuUpload,
  LuTrash2,
  LuMove,
  LuRotateCw,
  LuRotateCcw,
  LuMaximize2,
  LuMaximize,
  LuSettings2,
  LuMic,
  LuArrowUp,
  LuArrowDown,
  LuArrowLeft,
  LuArrowRight,
  LuCircleDot,
  LuClapperboard,
  LuFilm,
  LuSparkles,
  LuPlus,
  LuMinus,
  LuEye,
  LuMousePointerClick,
  LuAlignLeft,
  LuAlignCenter,
  LuAlignRight,
  LuBold,
  LuItalic,
  LuUnderline,
} from "react-icons/lu";

/**
 * Hareketli Görsel'in "AI ile düzenle" penceresini açar. Pencere burada değil
 * MotionAiEditHost'ta: pill seçimle birlikte kayboluyor, düzenleme ise
 * dakikalar sürüyor.
 */
function openMotionAiEdit(boxId) {
  window.dispatchEvent(new CustomEvent(MOTION_AI_EDIT_EVENT, { detail: { boxId } }));
}

/** "MP4'e çevir" penceresi — aynı sahip bileşende (MotionAiEditHost). */
function openMotionToVideo(boxId) {
  window.dispatchEvent(new CustomEvent(MOTION_TO_VIDEO_EVENT, { detail: { boxId } }));
}

/**
 * EditorShortcuts component
 * Floating tools that help edit EditorBoxes more easily
 */
export default class EditorShortcuts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      left: 0,
      top: 0,
      width: 0,
      open: false,
      showOverlay: false,
      urlValue: "",
      displayArrows: 0,
      showLipsyncModal: false,
      showImageAnimatorModal: false,
      showImageClickModal: false,
      // Aidea Wizard op + settings the chat agent asked to open on this image (or null).
      imageAnimatorInitial: null,
      alignmentButtonsAbove: false,
      // Bumped when an async reference-image probe resolves → re-render the pill.
      refImageProbeTick: 0,
    };

    this.resizeAndSetState = this.resizeAndSetState.bind(this);
    // this.handleChange = this.handleChange.bind(this);
    this.containerRef = createRef();
    this.urlInputRef = createRef();
    this.innerContainerRef = createRef();
    this.onLipsyncModalToggle = this.onLipsyncModalToggle.bind(this);
    this.onLipsyncComplete = this.onLipsyncComplete.bind(this);
    this.getSceneAudios = this.getSceneAudios.bind(this);
    this.onImageAnimatorModalToggle = this.onImageAnimatorModalToggle.bind(this);
    this.onEditAnimationSource = this.onEditAnimationSource.bind(this);
    // Chat agent → open Aidea Wizard on THIS image (when it's the selected image box).
    this.onOpenImageAnimatorRequest = this.onOpenImageAnimatorRequest.bind(this);
    // DEPRECATED
    this.onAcceptAnimation = this.onAcceptAnimation.bind(this);
  }

  // Applies one text-format key/value (bold/italic/underline/textAlign/
  // textFontFamily/textFontSize/textColor/highlightColor) to a BasicText or
  // RichText box: updates the box-state property (as before) AND, when the
  // box has rich __text content (RichText, or older BasicText content from
  // before its native toolbar was hidden), forces the matching CSS property
  // onto every element of that stored HTML too — otherwise a per-span style
  // (from CKEditor's own toolbar, or a PREVIOUS format change applied here or
  // via the multi-select bar) keeps winning over the new wrapper-level value
  // and the change looks like it silently did nothing. Mirrors EditorApp.jsx's
  // applyMultiTextValue exactly, so single- and multi-select behave the same.
  applyTextFormatValue(id, currentText, key, value) {
    this.props.onToolbarUpdated(id, "main", "state", key, value);
    if (!currentText) return;
    // Font size is em-based: forcing it onto content elements MULTIPLIES with
    // the wrapper's own em (1.29em × 1.29em ≈ +29%) — strip it from content
    // instead, so the wrapper is the single owner and per-span sizes still
    // can't shadow the new value. Mirrors EditorApp.applyMultiTextValue.
    if (key === "textFontSize") {
      this.props.onToolbarUpdated(
        id,
        "main",
        "state",
        "__text",
        stripHtmlCssProperty(currentText, "font-size")
      );
      return;
    }
    const mapping = TEXT_FORMAT_CSS_PROP[key];
    if (mapping) {
      const [cssProp, toCssValue] = mapping;
      const nextHtml = (
        TEXT_TOGGLE_KEYS.includes(key) ? toggleHtmlCssProperty : forceHtmlCssProperty
      )(currentText, cssProp, toCssValue(value));
      this.props.onToolbarUpdated(id, "main", "state", "__text", nextHtml);
    }
  }

  // Live font preview while browsing the inline font list: applies the
  // hovered font to the box's own DOM node AND every descendant (not a Redux
  // dispatch, so hovering every row in the list doesn't spam undo history) —
  // touching every descendant matters once a PREVIOUS commit has forced a
  // font onto each element of __text (see applyTextFormatValue above), since
  // otherwise those per-element inline styles keep out-ranking a preview that
  // only touched the box's wrapper. `value: null` (mouse/focus leaves a row)
  // restores each element's exact prior value via the snapshot
  // previewCssOnBox returned from the last call.
  previewFontFamily(id, value) {
    this._fontPreviewSnapshot = previewCssOnBox(
      getBoxContentEl(id),
      "fontFamily",
      value,
      this._fontPreviewSnapshot
    );
  }

  // Handle the chat agent's `aidea:openImageAnimator` request. Only the toolbar
  // of the CURRENTLY SELECTED image box responds (so we open Aidea Wizard on the image
  // the user is editing, not every image box's toolbar). Stores the requested
  // operation + settings so ImageAnimatorModal opens pre-set to that edit.
  // Publish the currently selected element to a window global so the Aidea
  // Assistant chat can forward it (as a request header) and the agent can reason
  // about "this image / this box" without the user re-describing it. EditorShortcuts
  // is the toolbar for the SELECTED box (rendered once in EditorCanvasDoc as
  // boxes[boxSelected]), so our props ARE the selection. Keep the payload tiny:
  // boxId + plugin type + the image URL (when the element has one).
  publishSelectedElement() {
    if (typeof window === "undefined") return;
    try {
      const toolbar = this.props.pluginToolbar;
      const box = this.props.box;
      if (!box || !toolbar) {
        window.__aideaSelectedElement = undefined;
        return;
      }
      const url = toolbar?.state?.url || undefined;
      window.__aideaSelectedElement = {
        boxId: box.id,
        type: toolbar.pluginId || undefined,
        imageUrl: url,
      };
    } catch {
      /* non-fatal — selection context is best-effort */
    }
  }

  onOpenImageAnimatorRequest(e) {
    const detail = e?.detail || {};
    const operation = detail.operation || detail.settings?.operation;

    // Only PNG/JPG can be animated. Block early on a known non-animatable source
    // (webp/mp4/gif/...) so we neither select the box nor open Aidea Wizard into a
    // failing animate. The agent also refuses these with a chat message; this is
    // the editor-side backstop.
    if (operation === "animate") {
      const probe = detail.imageUrl || this.props.pluginToolbar?.state?.url || "";
      if (!isAnimatableImageUrl(probe)) {
        // eslint-disable-next-line no-console
        console.warn("[EditorShortcuts] Animate blocked — only PNG/JPG can be animated:", probe);
        return;
      }
    }

    // The chat may tell us WHICH image to edit (detail.boxId / detail.navId from
    // the editImage tool result). Aidea Wizard's modal only renders for the SELECTED
    // box (EditorShortcuts returns null when nothing is selected), so when a
    // target is given but isn't the current selection — e.g. the user clicked
    // "Open" on a restored conversation with nothing selected — we select it
    // here. The chat re-fires this event at 0/500/1100ms, so a later fire opens
    // Aidea Wizard once our props reflect the new selection. We bail this round.
    if (detail.boxId && this.props.store) {
      try {
        const present = this.props.store.getState()?.undoGroup?.present;
        const curSel = present?.boxSelected;
        if (curSel !== detail.boxId) {
          const targetBox = present?.boxesById?.[detail.boxId];
          if (targetBox) {
            // If the image lives on another scene, switch to it first (a nav
            // switch resets the box selection, so it must precede selectBox).
            if (detail.navId && present?.navItemSelected !== detail.navId) {
              this.props.store.dispatch(selectNavItem(detail.navId));
            }
            this.props.store.dispatch(selectBox(detail.boxId, targetBox));
            return;
          }
        }
      } catch {
        /* fall through to the selection-based open below */
      }
    }

    // EditorShortcuts is the toolbar for the CURRENTLY SELECTED box (rendered
    // once in EditorCanvasDoc as boxes[boxSelected]), so if it has an image we
    // ARE the selected image — open Aidea Wizard on it. (No boxSelectedAll check: that
    // prop isn't passed here, and the earlier guard wrongly blocked every open.)
    const hasImage = !!this.props.pluginToolbar?.state?.url;
    if (!hasImage) return;
    this.setState({
      showImageAnimatorModal: true,
      imageAnimatorInitial: {
        operation: detail.operation,
        // Merge the prompt into a single stable settings object so the modal's
        // apply-effect can read it (and the object identity stays stable until
        // the next open, avoiding effect re-runs each render).
        settings: {
          ...(detail.settings || {}),
          ...(detail.prompt ? { prompt: detail.prompt } : {}),
        },
        // Task 37 ASK 4: carried through to ImageAnimatorModal's `returnTo`
        // prop so it can render a Back control when it was opened from
        // AnimatorPanel's per-card action (detail.returnTo = { panel, navId }).
        returnTo: detail.returnTo || null,
      },
    });
    try {
      setPopupDocked(true);
    } catch {
      /* gateway not loaded — non-fatal */
    }
  }

  // When the over-box trash is clicked while a *nested answer line* is selected,
  // do a real reflow instead of a bare box delete: shift the answers below it up,
  // fix the correct-answer index, and shrink nBoxes — so the line is removed, the
  // count drops, and A/B/C re-letter automatically (letters are index-driven in
  // getRenderTemplate). Returns true if it handled the delete (caller should stop).
  //
  // DragDrop is intentionally excluded here — its answers are coupled to {{#N}}
  // slot markers in the question text and need slot renumbering, handled separately.
  removeAnswerLineIfApplicable() {
    const box = this.props.box;
    if (!box || typeof box.container !== "string") return false;
    const m = box.container.match(/^sc-Answer(\d+)$/);
    if (!m) return false;
    const k = parseInt(m[1], 10);
    const present = this.props.store && this.props.store.getState().undoGroup.present;
    if (!present) return false;

    // Shared reflow (same path as the inline per-row ×). The DnD-flavoured
    // setCorrectAnswer prop would array-wrap, so dispatch the non-DnD action.
    return applyAnswerRemoval(
      {
        boxes: present.boxesById,
        pluginToolbars: present.pluginToolbarsById,
        exercises: present.exercises,
      },
      box.parent,
      k,
      {
        setText: (id, text) => this.props.onTextEditorToggled(id, false, text, id),
        setCorrectAnswer: (id, ca, page) =>
          this.props.store.dispatch(setCorrectAnswer(id, ca, page)),
        setNBoxes: (id, n) => this.props.onToolbarUpdated(id, "main", "state", "nBoxes", n),
      }
    );
  }

  // Add an answer/blank/slot to the selected assessment box. Handles complex
  // plugins (container creation via toolbarUpdated) plus DragDrop {{#N}} and
  // FillInBlank #----# question markers. Reused by the legacy nBoxes row and
  // the new AssessmentBoxMenu.
  addAnswer() {
    const box = this.props.box;
    const toolbar = this.props.pluginToolbar;
    if (!box || !toolbar) return;
    const oldNBoxes = toolbar.state.nBoxes;
    // ponytail: rows now share the box height (no scroll), so the count
    // can't exceed the per-plugin cap or rows become illegible.
    if (oldNBoxes >= 6) return;
    const newNBoxes = oldNBoxes + 1;

    this.props.onToolbarUpdated(box.id, "main", "state", "nBoxes", newNBoxes);

    if (
      box != null &&
      box.sortableContainers != null &&
      box.sortableContainers["sc-Question"] != null &&
      this.props.pluginToolbar.pluginId == "DragDrop"
    ) {
      var toolbars = this.props.pluginToolbars;
      var toolbarQuestion = toolbars[box.sortableContainers["sc-Question"].children[0]];

      let originalText = toolbarQuestion.state.__text;
      let isEncoded = originalText.includes("%");
      let questionText = originalText;

      try {
        if (isEncoded) {
          questionText = decodeURIComponent(originalText);
        }
      } catch (e) {
        // Decode hatası durumunda orijinal text kullan
      }

      var dropzoneIndex = newNBoxes;
      var text =
        "<p>" +
        questionText.replace("<p>", "").replace("</p>", "") +
        " {{#" +
        dropzoneIndex +
        "}}" +
        "</p>";

      this.props.onTextEditorToggled(
        toolbarQuestion.id,
        false,
        text,
        box.sortableContainers["sc-Question"].children[0]
      );
      // Set correct answer at the new dropzone index
      this.props.setCorrectAnswer(box.id, dropzoneIndex - 1, box.parent, oldNBoxes);
    } else if (
      box != null &&
      box.sortableContainers != null &&
      box.sortableContainers["sc-Question"] != null &&
      this.props.pluginToolbar.pluginId == "FillInBlank"
    ) {
      var toolbars = this.props.pluginToolbars;
      var toolbarQuestion = toolbars[box.sortableContainers["sc-Question"].children[0]];

      let originalText = toolbarQuestion.state.__text;
      let isEncoded = originalText.includes("%");
      let questionText = originalText;

      try {
        if (isEncoded) {
          questionText = decodeURIComponent(originalText);
        }
      } catch (e) {
        // Decode hatası durumunda orijinal text kullan
      }

      var text =
        "<p>" + questionText.replace("<p>", "").replace("</p>", "") + " #----answer----#" + "</p>";
      this.props.onTextEditorToggled(
        toolbarQuestion.id,
        false,
        text,
        box.sortableContainers["sc-Question"].children[0]
      );
      this.props.setCorrectAnswer(box.id, "", box.parent);
    }
  }

  // Remove the last answer/blank/slot from the selected assessment box.
  removeAnswer() {
    const box = this.props.box;
    const toolbar = this.props.pluginToolbar;
    if (!box || !toolbar) return;
    // En az 1 cevap kalmalı (nBoxes >= 1)
    if (toolbar.state.nBoxes > 1) {
      const oldNBoxes = toolbar.state.nBoxes;
      const newNBoxes = oldNBoxes - 1;
      if (
        box != null &&
        box.sortableContainers != null &&
        box.sortableContainers["sc-Question"] != null &&
        this.props.pluginToolbar.pluginId == "DragDrop"
      ) {
        let toolbars = this.props.pluginToolbars;
        let toolbarQuestion = toolbars[box.sortableContainers["sc-Question"].children[0]];

        let draggableIndexes = [];
        for (let i = 0; i < oldNBoxes; i++) {
          if (box.sortableContainers["sc-Answer" + i]) {
            draggableIndexes.push(i);
          }
        }

        let originalText = toolbarQuestion.state.__text;
        let isEncoded = originalText.includes("%");
        let text = originalText;

        try {
          if (isEncoded) {
            text = decodeURIComponent(originalText);
          }
        } catch (e) {
          // Decode hatası durumunda orijinal text kullan
        }

        const dropzonePattern = /\{\{#(\d+)\}\}/g;
        const matches = [...text.matchAll(dropzonePattern)];
        let dropzoneIndexes = matches.map((m) => parseInt(m[1]) - 1);

        let allIndexes = [...draggableIndexes, ...dropzoneIndexes];
        let maxIndex = Math.max(...allIndexes);

        let dropzoneToRemove = maxIndex + 1;
        let hasDropzone = dropzoneIndexes.includes(maxIndex);

        let newText = text;
        if (hasDropzone) {
          newText = text.replace("{{#" + dropzoneToRemove + "}}", "");
        }

        this.props.onTextEditorToggled(
          toolbarQuestion.id,
          false,
          newText,
          box.sortableContainers["sc-Question"].children[0]
        );
      } else if (
        box != null &&
        box.sortableContainers != null &&
        box.sortableContainers["sc-Question"] != null &&
        this.props.pluginToolbar.pluginId == "FillInBlank"
      ) {
        let toolbars = this.props.pluginToolbars;
        let toolbarQuestion = toolbars[box.sortableContainers["sc-Question"].children[0]];

        let originalText = toolbarQuestion.state.__text;
        let isEncoded = originalText.includes("%");
        let text = originalText;

        try {
          if (isEncoded) {
            text = decodeURIComponent(originalText);
          }
        } catch (e) {
          // Decode hatası durumunda orijinal text kullan
        }

        // Son "#----…----#" işaretçisini (ve varsa önündeki boşluğu) kaldır.
        const blankPattern = /\s*#----.*?----#/g;
        const matches = [...text.matchAll(blankPattern)];
        let newText = text;
        if (matches.length > 0) {
          const last = matches[matches.length - 1];
          newText = text.slice(0, last.index) + text.slice(last.index + last[0].length);
        }

        this.props.onTextEditorToggled(
          toolbarQuestion.id,
          false,
          newText,
          box.sortableContainers["sc-Question"].children[0]
        );
      }

      this.props.onToolbarUpdated(box.id, "main", "state", "nBoxes", newNBoxes);
    }
  }

  render() {
    let box = this.props.box;
    let toolbar = this.props.pluginToolbar;
    let animationCount = this.props.animationById ? this.props.animationById.length : 0;

    if (!box || !toolbar || toolbar.pluginId === "sortable_container") {
      return null;
    }
    let apiPlugin = IdealStudio.Plugins.get(toolbar.pluginId);
    if (!apiPlugin) {
      return null;
    }
    const boxSelectedAll = this.props.boxSelectedAll;
    if (Array.isArray(boxSelectedAll) && boxSelectedAll.length > 1) {
      return null;
    }

    // Assessment question/answer text is edit-only (1-click inline edit): no
    // legacy over-box toolbar (resize / edit / delete) on the nested text — the
    // assessment box itself owns those controls + the inline grip / × / + Add.
    // BasicText children are the exception: they still need the rich-text
    // formatting pill (font/bold/align), just not the legacy button row —
    // that's kept hidden below via `nestedInEval` on toolbar_el's display.
    const parentTb =
      box.parent && this.props.pluginToolbars && this.props.pluginToolbars[box.parent];
    const nestedInEval = parentTb && isEvalPlugin(parentTb.pluginId);
    if (nestedInEval && toolbar.pluginId !== "BasicText") {
      return null;
    }

    // Assessment boxes (top-level evaluation plugins) get the new Gamma-style
    // menu instead of the legacy button row. Nested answers (BasicText, container
    // "sc-AnswerN") and every non-assessment element keep the legacy toolbar.
    if (isEvalPlugin(toolbar.pluginId) && box.container === 0) {
      const page =
        this.props.containedViewSelected === 0
          ? this.props.navItemSelected
          : this.props.containedViewSelected;
      const pageId = page && page.id ? page.id : page || 0;
      // Current per-box score (weight). Exercises are keyed page → box. The menu
      // reveals a "Puan" input under the "Kısmi puan" toggle so the author can
      // set how many points this question is worth.
      const present = this.props.store && this.props.store.getState().undoGroup.present;
      const pageEx = present && present.exercises && present.exercises[pageId];
      const boxEx = pageEx && pageEx.exercises && pageEx.exercises[box.id];
      const weight = boxEx && boxEx.weight != null ? boxEx.weight : 0;
      return (
        <AssessmentBoxMenu
          box={box}
          toolbar={toolbar}
          weight={weight}
          onSetWeight={(v) => this.props.store.dispatch(configScore(box.id, "weight", v, pageId))}
          pluginToolbars={this.props.pluginToolbars}
          store={this.props.store}
          left={this.state.left}
          top={this.state.top}
          onToolbarUpdated={this.props.onToolbarUpdated}
          onAddAnswer={() => this.addAnswer()}
          onRemoveAnswer={() => this.removeAnswer()}
          onFitScreen={() => this.fitBoxToScreen(box, toolbar)}
          onDuplicate={this.props.onDuplicateBox ? () => this.props.onDuplicateBox() : undefined}
          onPreview={this.props.visor ? () => this.props.visor() : undefined}
          onBoxDeleted={() => this.props.onBoxDeleted(box.id, box.parent, box.container, pageId)}
          openSettings={() => this.props.onOpenSettings && this.props.onOpenSettings()}
        />
      );
    }

    let config = apiPlugin.getConfig();
    let toolbarAcc = apiPlugin.getToolbar(toolbar.state);
    let hasURL = false;
    let hasURLnotextprov = false;
    let accept = "*";
    let callbackKey = "url";
    let createFromLibrary = config.createFromLibrary;
    let searchIcon = config.searchIcon;
    if (searchIcon) {
      if (searchIcon === "type") {
        hasURLnotextprov = true;
      } else {
        hasURL =
          searchIcon && searchIcon instanceof Array && searchIcon.length > 1
            ? searchIcon
            : createFromLibrary &&
                createFromLibrary instanceof Array &&
                createFromLibrary.length > 1
              ? createFromLibrary
              : ["*", "url"];
        accept = hasURL[0];
        callbackKey = hasURL[1];
      }
    }
    let boxEl = findBox(box ? box.id : "");
    let nBoxes = [
      { i18nKey: "add_answer", icon: "playlist_add", callback: () => this.addAnswer() },
      { i18nKey: "remove_answer", icon: "delete_sweep", callback: () => this.removeAnswer() },
    ];
    const portalRoot = document.getElementById("editorBoxIconsRoot");
    const toolbar_el = (
      <div
        id={this.props.isContained ? "contained_editorBoxIcons" : "editorBoxIcons"}
        className=""
        onClick={(e) => {
          e.stopPropagation();
        }}
        onMouseDown={(e) => {
          e.stopPropagation();
        }}
        ref={this.containerRef}
        style={{
          display:
            (box && box.id && isSortableBox(box.id)) || !box || !box.id || nestedInEval
              ? "none"
              : "inline-flex",
          position: "absolute",
          left: this.state.left,
          top: this.state.top,
          pointerEvents: "auto",
        }}
      >
        <div
          ref={this.innerContainerRef}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
            height: "100%",
          }}
        >
          <span className="namePlugin">{config.displayName || ""}</span>
          <Overlay
            rootClose
            name="urlOverlay"
            show={this.state.showOverlay}
            placement="top"
            target={() => this.overlayTarget}
            onHide={() => this.setState({ showOverlay: false })}
          >
            <Popover id="popov" title={i18n.t("messages.popoverUrlTitle")} className="popoverURL">
              <div style={{ display: "block" }}>
                <div style={{ padding: "10px 0" }}>
                  i18n.t('messages.websitePluginWarning'){" "}
                  {/* Baz� websiteler iframe �zelli�ini engelledi�inden dolay� eklenemeyebilir*/}{" "}
                </div>
                <div style={{ display: "flex" }}>
                  <input
                    type="text"
                    className="form-control"
                    ref={this.urlInputRef}
                    placeholder={"http://... "}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        let val = this.urlInputRef.current.value;
                        if (val && val !== "") {
                          this.props.onToolbarUpdated(
                            toolbar.id,
                            "main",
                            "state",
                            "url",
                            this.urlInputRef.current.value
                          );
                        }
                        this.setState({ showOverlay: false });
                      }
                    }}
                  />
                  <Button
                    className="popoverButton"
                    name="popoverAcceptButton"
                    // disabled={ this.state.urlValue === ""}
                    onClick={(e) => {
                      let val = this.urlInputRef.current.value;
                      if (val && val !== "") {
                        this.props.onToolbarUpdated(
                          toolbar.id,
                          "main",
                          "state",
                          "url",
                          this.urlInputRef.current.value
                        );
                      }
                      this.setState({ showOverlay: false });
                    }}
                  >
                    {i18n.t("Accept")}
                  </Button>
                </div>
              </div>
            </Popover>
          </Overlay>
          {hasURLnotextprov ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="config">{i18n.t("messages.Change")}</Tooltip>}
            >
              <button
                id="open_conf"
                className={"editorTitleButton"}
                ref={(button) => {
                  this.overlayTarget = button;
                }}
                onClick={(e) => {
                  this.setState({ showOverlay: true });
                }}
              >
                <LuPen />
              </button>
            </OverlayTrigger>
          ) : null}
          {hasURL ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="config">{i18n.t("messages.Change")}</Tooltip>}
            >
              <button
                id="open_conf"
                className={"editorTitleButton"}
                onClick={(e) => {
                  this.props.openFileModal(box.id, accept);
                  this.setState({ open: true, callbackKey });
                }}
              >
                <LuPen />
              </button>
            </OverlayTrigger>
          ) : null}
          {config.isRich ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="richMark">{i18n.t("messages.add_new_mark")}</Tooltip>}
            >
              <button
                id="markCreatorButton"
                className="editorTitleButton"
                onMouseDown={(e) => {
                  e.preventDefault();
                  this.props.onMarkCreatorToggled(box.id);
                }}
              >
                <i key="i" style={{ color: this.props.color }} className="material-icons">
                  room
                </i>
              </button>
            </OverlayTrigger>
          ) : null}
          {config.isRich ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="fitToScreen">{i18n.t("fitToScreen")}</Tooltip>}
            >
              <button
                className="editorTitleButton"
                onClick={(e) => {
                  e.stopPropagation();
                  this.props.onBoxResized(toolbar.id, {
                    width: "100",
                    widthUnit: "%",
                    height: "100",
                    heightUnit: "%",
                  });
                  this.props.onBoxMoved(box.id, "0%", "0%", "absolute", box.parent, box.container);
                }}
              >
                <LuMaximize />
              </button>
            </OverlayTrigger>
          ) : null}

          {toolbar.pluginId === "AtomicBoxPlugin" ? (
            <>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="fontScaleUp">{i18n.t("messages.increase_text_size")}</Tooltip>
                }
              >
                <button
                  className="editorTitleButton"
                  style={{ lineHeight: 1 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    const cur = toolbar.state.fontScale || 1;
                    this.props.onToolbarUpdated(
                      box.id,
                      "main",
                      "state",
                      "fontScale",
                      Math.min(parseFloat((cur + 0.15).toFixed(2)), 2.0)
                    );
                  }}
                >
                  <span style={{ fontWeight: 600, fontSize: "18px", color: "#4b5563" }}>A</span>
                </button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="fontScaleDown">{i18n.t("messages.decrease_text_size")}</Tooltip>
                }
              >
                <button
                  className="editorTitleButton"
                  style={{ lineHeight: 1 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    const cur = toolbar.state.fontScale || 1;
                    this.props.onToolbarUpdated(
                      box.id,
                      "main",
                      "state",
                      "fontScale",
                      Math.max(parseFloat((cur - 0.15).toFixed(2)), 0.4)
                    );
                  }}
                >
                  <span style={{ fontWeight: 600, fontSize: "18px", color: "#4b5563" }}>a</span>
                </button>
              </OverlayTrigger>
            </>
          ) : null}

          {toolbar?.pluginId === "HotspotImages" &&
          !/\.(gif|webp)(\?|#|$)/i.test(toolbar?.state?.url || "") ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="Merlin">{i18n.t("Merlin")}</Tooltip>}
            >
              <button
                className="editorTitleButton"
                onClick={(e) => {
                  // Merkezi modal yerine sağdaki Aidea Wizard panelini aç (right strip
                  // Aidea Wizard ikonuyla aynı yüzey). EditorApp bu event'i dinliyor.
                  window.dispatchEvent(
                    new CustomEvent("aidea:openMerlinPanel", {
                      detail: { boxId: this.props.box?.id },
                    })
                  );
                  e.stopPropagation();
                }}
              >
                <LuSparkles />
              </button>
            </OverlayTrigger>
          ) : null}

          {/* Lipsync temporarily hidden
          {toolbar.pluginId === "EnrichedPlayer" ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="lipsyncing">{i18n.t("Lipsyncing")}</Tooltip>}
            >
              <button
                className="editorTitleButton"
                onClick={(e) => {
                  this.onLipsyncModalToggle();
                  e.stopPropagation();
                }}
              >
                <LuMic />
              </button>
            </OverlayTrigger>
          ) : null}
          */}

          {animationCount > 1 ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="borrarcaja">{i18n.t("EditAnimation")}</Tooltip>}
            >
              <button
                className="editorTitleButton"
                onClick={(e) => {
                  this.props.onAddNewAnimationModalToggled(null, box.id);
                }}
              >
                <LuSparkles />
              </button>
            </OverlayTrigger>
          ) : null}
          {/*    {*/}
          {/*    <OverlayTrigger placement="top"*/}
          {/*    overlay={*/}
          {/*        <Tooltip id="borrarcaja">*/}
          {/*            {i18n.t('AddStartAnimation')}*/}
          {/*        </Tooltip>*/}
          {/*    }>*/}
          {/*    <button className="editorTitleButton"*/}
          {/*        onClick={(e) => {*/}

          {/*            var boxdiv = document.getElementById("box-" + box.id);*/}

          {/*             this.props.onBoxStartAnimation(box.id,box.position.x,box.position.y,boxdiv.style.width,boxdiv.style.height,box.parent,box.container);*/}

          {/*            if(box.endanimation.lastpositionx != 0 && (box.finalanimation.positionNumber != 3 || (box.middleanimation != null && box.middleanimation.middlepositionx != 0))) {*/}
          {/*                setTimeout( () => {*/}
          {/*                    this.props.onAddNewAnimationModalToggled(null,box.id);*/}
          {/*                }, 0);                            */}
          {/*            }*/}

          {/*        }}*/}
          {/*        >*/}
          {/*        <i className="material-icons">add-new-animation</i>*/}
          {/*    </button>*/}
          {/* </OverlayTrigger>*/}
          {/*    }*/}
          {/* {box.finalanimation.positionNumber == 3 ?*/}
          {/* <OverlayTrigger placement="top"*/}
          {/* overlay={*/}
          {/*    <Tooltip id="borrarcaja">*/}
          {/*        {i18n.t('AddMiddleAnimation')}*/}
          {/*    </Tooltip>*/}
          {/* }>*/}
          {/* <button className="editorTitleButton"*/}
          {/*    onClick={(e) => {*/}

          {/*        var boxdiv = document.getElementById("box-" + box.id);*/}

          {/*         this.props.onBoxMiddleAnimation(box.id,box.position.x,box.position.y,boxdiv.style.width,boxdiv.style.height,box.parent,box.container);*/}

          {/*        if(box.endanimation.lastpositionx != 0 &&  box.startanimation.firstpositionx != 0 ) {*/}
          {/*            setTimeout( () => {*/}
          {/*                this.props.onAddNewAnimationModalToggled(null,box.id);*/}
          {/*            }, 0);                            */}
          {/*        }*/}

          {/*    }}*/}
          {/*    disabled={box.startanimation.firstpositionx == 0 }*/}
          {/*    >*/}
          {/*    <i className="material-icons">add-new-animation</i>*/}
          {/* </button>*/}
          {/* </OverlayTrigger> : null*/}
          {/* }*/}

          {/*    {*/}
          {/*    <OverlayTrigger placement="top"*/}
          {/*    overlay={*/}
          {/*        <Tooltip id="borrarcaja">*/}
          {/*            {i18n.t('AddEndAnimation')}*/}
          {/*        </Tooltip>*/}
          {/*    }>*/}
          {/*    <button className="editorTitleButton"*/}
          {/*        onClick={(e) => {*/}

          {/*            var boxdiv = document.getElementById("box-" + box.id);*/}

          {/*             this.props.onBoxEndAnimation(box.id, box.position.x, box.position.y,boxdiv.style.width,boxdiv.style.height, box.parent, box.container);*/}

          {/*            if(box.startanimation.firstpositionx != 0 && (box.finalanimation.positionNumber != 3 || (box.middleanimation != null && box.middleanimation.middlepositionx != 0)) ) {*/}
          {/*               // this.props.onBoxMoved(box.id,box.startanimation.firstpositionx,box.startanimation.firstpositiony,"absolute",box.parent,box.container);*/}
          {/*                setTimeout( () => {*/}
          {/*                    this.props.onAddNewAnimationModalToggled(null,box.id);*/}
          {/*                },0);*/}
          {/*            }*/}

          {/*        }}*/}
          {/*        disabled={box.startanimation.firstpositionx == 0}>*/}
          {/*        <i className="material-icons">add-new-animation</i>*/}
          {/*    </button>*/}
          {/* </OverlayTrigger> */}
          {/*    }*/}

          {isSortableContainer(box.container) ? (
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="ajustaradocumento">{i18n.t("messages.adjust_to_document")}</Tooltip>
              }
            >
              <button
                className="editorTitleButton"
                onClick={(e) => {
                  if (toolbar && toolbar.structure) {
                    let currentWidth = toolbar.structure.width;
                    let currentWidthUnit = toolbar.structure.widthUnit;
                    if (currentWidth === "100" && currentWidthUnit === "%") {
                      if (config.needsTextEdition) {
                        currentWidth = "auto";
                      } else {
                        currentWidth = "20";
                        currentWidthUnit = "%";
                      }
                    } else {
                      currentWidth = "100";
                      currentWidthUnit = "%";
                    }
                    this.props.onBoxResized(toolbar.id, {
                      width: currentWidth,
                      widthUnit: currentWidthUnit,
                    });
                  }
                }}
              >
                <LuMaximize2 />
              </button>
            </OverlayTrigger>
          ) : null}
          {config && config.needsTextEdition ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="editartexto">{i18n.t("messages.edit_text")}</Tooltip>}
            >
              <button
                className="editorTitleButton"
                onClick={(e) => {
                  blurCKEditor(toolbar.id, (text, content) => {
                    this.props.onTextEditorToggled(
                      toolbar.id,
                      !toolbar.showTextEditor,
                      text,
                      content
                    );
                  });
                  e.stopPropagation();
                }}
              >
                <LuPen />
              </button>
            </OverlayTrigger>
          ) : null}
          {config && config.needsConfigModal ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="config">{i18n.t("open_conf")}</Tooltip>}
            >
              <button
                id="open_conf"
                className={"editorTitleButton"}
                onClick={(e) => {
                  // TODO Cambiar!
                  this.props.openConfigModal(toolbar.id);
                  // IdealStudio.Plugins.get(toolbar.pluginId).openConfigModal(UPDATE_BOX, toolbar.state, toolbar.id);
                }}
              >
                {/* Plugin ayarları */}
                <LuSettings2 />
              </button>
            </OverlayTrigger>
          ) : null}
          {toolbar && config && config.needsPointerEventsAllowed ? (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="editartexto">{i18n.t("messages.pointer_events")}</Tooltip>}
            >
              <button
                id="pebutton"
                className={
                  boxEl && boxEl.classList.contains("pointerEventsEnabled")
                    ? "editorTitleButton dtbSelected"
                    : "editorTitleButton"
                }
                onClick={(e) => {
                  boxEl.classList.toggle("pointerEventsEnabled");
                  let but = document.getElementById("pebutton");
                  e.stopPropagation();
                  let bool = boxEl.classList.contains("pointerEventsEnabled");
                  if (this.props.pointerEventsCallback) {
                    this.props.pointerEventsCallback(bool ? "enableAll" : "disableAll", ttoolbar);
                  }
                  bool && but
                    ? but.classList.add("dtbSelected")
                    : but.classList.remove("dtbSelected");
                }}
              >
                <LuMove />
              </button>
            </OverlayTrigger>
          ) : null}
          {toolbar && toolbar.state && toolbar.state.nBoxes
            ? nBoxes.map((nBox, i) => {
                return (
                  <OverlayTrigger
                    key={i}
                    placement="top"
                    overlay={
                      <Tooltip id="editartexto">{i18n.t("messages." + nBox.i18nKey)}</Tooltip>
                    }
                  >
                    <button
                      id="pebutton"
                      className={"editorTitleButton"}
                      onClick={(e) => {
                        nBox.callback();
                        e.stopPropagation();
                      }}
                    >
                      {nBox.icon === "playlist_add" ? <LuPlus /> : <LuMinus />}
                    </button>
                  </OverlayTrigger>
                );
              })
            : null}
          {this.props.pluginToolbar.pluginId == "OneClick" && (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="editartexto">{i18n.t("marks.edit_mark_to")}</Tooltip>}
            >
              <button
                className="editorTitleButton"
                onClick={(e) => {
                  let mark = this.props.marks
                    ? Object.keys(this.props.marks)
                        .map((key) => this.props.marks[key])
                        .find((r) => r.origin == box.id)
                    : null;

                  if (mark != null) {
                    this.props.onRichMarkEditPressed(mark);
                  }
                  this.props.onOneClickEditModalToggled();
                }}
              >
                <LuPen />
              </button>
            </OverlayTrigger>
          )}
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="borrarcaja">{i18n.t("messages.erase_plugin")}</Tooltip>}
          >
            <button
              className="editorTitleButton"
              // Stop the mousedown from bubbling to the canvas/box, otherwise
              // a parent handler can dispatch selectInteractiveItem(null, null)
              // before this onClick runs and we lose the sub-item context.
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => {
                e.stopPropagation();
                // A nested answer line gets a real reflow-delete; everything else
                // falls through to the normal whole-box delete.
                if (this.removeAnswerLineIfApplicable()) return;
                // Context-aware Delete: when an InteractivePlugin sub-item is
                // selected (interactivityStudio.selectedItemId), remove the sub-item
                // only — not the whole container box. Falls back to standard box
                // delete in all other cases.
                const storeState =
                  this.props.store && typeof this.props.store.getState === "function"
                    ? this.props.store.getState()
                    : null;
                const istudio = storeState && storeState.interactivityStudio;
                const selectedItemId = istudio && istudio.selectedItemId;
                if (selectedItemId && toolbar.pluginId === "InteractivePlugin") {
                  this.props.store.dispatch(removeInteractiveItem(box.id, selectedItemId));
                  return;
                }
                let page =
                  this.props.containedViewSelected === 0
                    ? this.props.navItemSelected
                    : this.props.containedViewSelected;
                this.props.onBoxDeleted(
                  box.id,
                  box.parent,
                  box.container,
                  page && page.id ? page.id : 0
                );
              }}
            >
              <LuTrash2 />
            </button>
          </OverlayTrigger>

          {/* <OverlayTrigger placement="top"
                        overlay={
                            <Tooltip id="borrarcaja">
                                {i18n.t('')}
                            </Tooltip>
                        }> </OverlayTrigger> */}
          <div
            className="alignmentButtons"
            style={{
              display: this.state.displayArrows === 1 ? "inline-table" : "none",
              width: "104px",
              position: "absolute",
              backgroundColor: "#fff",
              top: "0px",
              zIndex: 1000,
            }}
          >
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "2px" }}>
              {/* Top row */}
              <button
                className="editorTitleButton"
                style={{
                  display: this.state.displayArrows === 1 ? "block" : "none",
                }}
                onClick={(e) => {
                  this.props.onBoxMoved(box.id, "0%", "0%", "absolute", box.parent, box.container);
                  e.persist();
                }}
              >
                <LuArrowUp style={{ transform: "rotate(-45deg)" }} />
              </button>
              <button
                className="editorTitleButton"
                style={{
                  display: this.state.displayArrows === 1 ? "block" : "none",
                }}
                onClick={(e) => {
                  let boxdiv = document.getElementById("box-" + box.id);
                  let positionX = (100 - Number(boxdiv.style.width.replace("%", ""))) / 2 + "%";
                  this.props.onBoxMoved(
                    box.id,
                    positionX,
                    "0%",
                    "absolute",
                    box.parent,
                    box.container
                  );
                  e.persist();
                }}
              >
                <LuArrowUp />
              </button>
              <button
                className="editorTitleButton"
                style={{
                  display: this.state.displayArrows === 1 ? "block" : "none",
                }}
                onClick={(e) => {
                  let boxdiv = document.getElementById("box-" + box.id);
                  let positionX = 100 - Number(boxdiv.style.width.replace("%", "")) + "%";
                  this.props.onBoxMoved(
                    box.id,
                    positionX,
                    "0%",
                    "absolute",
                    box.parent,
                    box.container
                  );
                  e.persist();
                }}
              >
                <LuArrowUp style={{ transform: "rotate(45deg)" }} />
              </button>

              {/* Middle row */}
              <button
                className="editorTitleButton"
                style={{
                  display: this.state.displayArrows === 1 ? "block" : "none",
                }}
                onClick={(e) => {
                  let positionY = this.getElementHeightPercent("box-" + box.id);
                  positionY = (100 - Number(positionY)) / 2 + "%";
                  this.props.onBoxMoved(
                    box.id,
                    "0%",
                    positionY,
                    "absolute",
                    box.parent,
                    box.container
                  );
                  e.persist();
                }}
              >
                <LuArrowLeft />
              </button>
              <button
                className="editorTitleButton"
                style={{
                  display: this.state.displayArrows === 1 ? "block" : "none",
                }}
                onClick={(e) => {
                  let boxdiv = document.getElementById("box-" + box.id);
                  let positionX = (100 - Number(boxdiv.style.width.replace("%", ""))) / 2 + "%";
                  let positionY = this.getElementHeightPercent("box-" + box.id);
                  positionY = (100 - Number(positionY)) / 2 + "%";
                  this.props.onBoxMoved(
                    box.id,
                    positionX,
                    positionY,
                    "absolute",
                    box.parent,
                    box.container
                  );
                  e.persist();
                }}
              >
                <LuCircleDot />
              </button>
              <button
                className="editorTitleButton"
                style={{
                  display: this.state.displayArrows === 1 ? "block" : "none",
                }}
                onClick={(e) => {
                  let boxdiv = document.getElementById("box-" + box.id);
                  let positionX = 100 - Number(boxdiv.style.width.replace("%", "")) + "%";
                  let positionY = this.getElementHeightPercent("box-" + box.id);
                  positionY = (100 - Number(positionY)) / 2 + "%";
                  this.props.onBoxMoved(
                    box.id,
                    positionX,
                    positionY,
                    "absolute",
                    box.parent,
                    box.container
                  );
                  e.persist();
                }}
              >
                <LuArrowRight />
              </button>

              {/* Bottom row */}
              <button
                className="editorTitleButton"
                style={{
                  display: this.state.displayArrows === 1 ? "block" : "none",
                }}
                onClick={(e) => {
                  let positionY = this.getElementHeightPercent("box-" + box.id);
                  positionY = 100 - Number(positionY) + "%";
                  this.props.onBoxMoved(
                    box.id,
                    "0%",
                    positionY,
                    "absolute",
                    box.parent,
                    box.container
                  );
                  e.persist();
                }}
              >
                <LuArrowDown style={{ transform: "rotate(45deg)" }} />
              </button>
              <button
                className="editorTitleButton"
                style={{
                  display: this.state.displayArrows === 1 ? "block" : "none",
                }}
                onClick={(e) => {
                  let boxdiv = document.getElementById("box-" + box.id);
                  let positionX = (100 - Number(boxdiv.style.width.replace("%", ""))) / 2 + "%";
                  let positionY = this.getElementHeightPercent("box-" + box.id);
                  positionY = 100 - Number(positionY) + "%";
                  this.props.onBoxMoved(
                    box.id,
                    positionX,
                    positionY,
                    "absolute",
                    box.parent,
                    box.container
                  );
                  e.persist();
                }}
              >
                <LuArrowDown />
              </button>
              <button
                className="editorTitleButton"
                style={{
                  display: this.state.displayArrows === 1 ? "block" : "none",
                }}
                onClick={(e) => {
                  let boxdiv = document.getElementById("box-" + box.id);
                  let positionX = 100 - Number(boxdiv.style.width.replace("%", "")) + "%";
                  let positionY = this.getElementHeightPercent("box-" + box.id);
                  positionY = 100 - Number(positionY) + "%";
                  this.props.onBoxMoved(
                    box.id,
                    positionX,
                    positionY,
                    "absolute",
                    box.parent,
                    box.container
                  );
                  e.persist();
                }}
              >
                <LuArrowDown style={{ transform: "rotate(-45deg)" }} />
              </button>
            </div>
          </div>
        </div>

        <LipsyncModal
          visible={this.state.showLipsyncModal}
          onClose={this.onLipsyncModalToggle}
          onLipsyncComplete={this.onLipsyncComplete}
          videoUrl={this.props.pluginToolbar?.state?.url || ""}
          getSceneAudios={this.getSceneAudios}
          onToolbarUpdated={this.props.onToolbarUpdated}
          uploadFunction={this.props.uploadFunction}
          editorProps={{
            pluginToolbar: this.props.pluginToolbar,
            box: this.props.box,
          }}
        />

        <ImageAnimatorModal
          visible={this.state.showImageAnimatorModal}
          onClose={this.onImageAnimatorModalToggle}
          // DEPRECATED: Remove this prop
          onAcceptAnimation={this.onAcceptAnimation}
          imageUrl={this.props.pluginToolbar?.state?.url || ""}
          boxId={this.props.box?.id}
          navId={this.props.navItemSelected?.id}
          sceneIndex={(() => {
            const present = this.props.store?.getState()?.undoGroup?.present;
            const navItemsIds = present?.navItemsIds ?? [];
            const navItemSelected = present?.navItemSelected ?? this.props.navItemSelected?.id;
            const sceneIndex = navItemsIds.indexOf(navItemSelected) + 1;
            return sceneIndex;
          })()}
          initialFeatureId={this.state.imageAnimatorInitial?.operation}
          initialSettings={this.state.imageAnimatorInitial?.settings}
          returnTo={this.state.imageAnimatorInitial?.returnTo || null}
          onEditSourceImage={this.onEditAnimationSource}
          onInsufficientBalance={notifyInsufficientBalance}
        />

        <ImageClickActionModal
          visible={this.state.showImageClickModal}
          onClose={() => this.setState({ showImageClickModal: false })}
          beforeUrl={this.props.pluginToolbar?.state?.url || ""}
          clickAction={this.props.pluginToolbar?.state?.clickAction}
          uploadFunction={this.props.uploadFunction}
          onSave={(value, newBefore) => {
            if (newBefore) {
              this.props.onToolbarUpdated(this.props.box.id, "main", "state", "url", newBefore);
            }
            this.props.onToolbarUpdated(this.props.box.id, "main", "state", "clickAction", value);
            this.setState({ showImageClickModal: false });
          }}
          onRemove={() => {
            this.props.onToolbarUpdated(this.props.box.id, "main", "state", "clickAction", null);
            this.setState({ showImageClickModal: false });
          }}
        />
      </div>
    );
    // Focused over-box "top pill" for purpose-driven elements. The legacy toolbar
    // above still renders (into the hidden #editorBoxIconsRoot, keeping its Aidea Wizard/
    // Lipsync modals alive); the pill is the only VISIBLE over-box control for these
    // types. Assessment boxes are handled earlier by AssessmentBoxMenu.
    let focusedPill = null;
    if (toolbar.pluginId === "OneClick") {
      focusedPill = (
        <TopActionPill
          left={this.state.left}
          top={this.state.top}
          actions={[
            {
              key: "interactivity",
              Icon: LuMousePointerClick,
              label: i18n.t("marks.edit_mark_to"),
              onClick: () => {
                const mark = this.props.marks
                  ? Object.keys(this.props.marks)
                      .map((k) => this.props.marks[k])
                      .find((r) => r.origin == box.id)
                  : null;
                if (mark != null) this.props.onRichMarkEditPressed(mark);
                this.props.onOneClickEditModalToggled();
              },
            },
          ]}
        />
      );
    } else if (config.category === "image") {
      // "Daha fazla seçenek" for HotspotImages — mirrors the video pill's gear
      // popover, surfacing the source URL + Zoom (scale) inline on the canvas so
      // they don't require opening the right-panel "Kaynak" section.
      // Genişlik / Yükseklik / En boy oranını koru — sağ panel "Araçlar → Yapı"
      // bölümündeki aynı resizeBox akışı (bkz. ToolsPanel.jsx "Structure"), url +
      // Zoom (scale) satırlarının yanına eklendi ki panel açmadan pill'den de
      // erişilebilsin. toggleAspect mantığı ToolsPanel'dekiyle birebir aynı:
      // kilitleyince height "auto" olur, kilit açılınca son bilinen değere döner.
      const imageStructure = toolbar.structure || {};
      const imageAspectLocked =
        imageStructure.aspectRatio === true ||
        !!(imageStructure.aspectRatio && imageStructure.aspectRatio.checked === true);
      const numOrEmpty = (v) =>
        v === "auto" || v === undefined || v === null ? "" : parseInt(v, 10);
      const setImageStructure = (patch) => this.props.store.dispatch(resizeBox(box.id, patch));
      const setStructure = (key, val) =>
        this.props.store.dispatch(updatePluginToolbar(box.id, "main", "structure", key, val));
      const clamp = (v, min, max) => Math.min(Math.max(v, min), max);
      const posX = box.position?.x != null ? parseInt(box.position.x, 10) || 0 : 0;
      const posY = box.position?.y != null ? parseInt(box.position.y, 10) || 0 : 0;
      const rotationVal = normalizeRotation(imageStructure.rotation);
      const imageMore =
        toolbar.pluginId === "HotspotImages"
          ? [
              {
                key: "aspectRatio",
                control: "toggle",
                label: i18n.t("AspectRatioLock"),
                hint: i18n.t("AspectRatioLockHint"),
                value: imageAspectLocked,
                onChange: () => {
                  const next = { aspectRatio: !imageAspectLocked };
                  if (!imageAspectLocked) {
                    if (imageStructure.height !== "auto") {
                      next.__heightBeforeAuto = imageStructure.height;
                      next.__heightUnitBeforeAuto = imageStructure.heightUnit;
                    }
                    next.height = "auto";
                  } else if (imageStructure.height === "auto") {
                    const prev = imageStructure.__heightBeforeAuto;
                    next.height = typeof prev === "number" ? prev : 44;
                    next.heightUnit = imageStructure.__heightUnitBeforeAuto || "%";
                  }
                  setImageStructure(next);
                },
              },
              // Genişlik + Yükseklik yan yana — ToolsPanel'in "Yapı" bölümündeki
              // pctCell çiftiyle aynı görünüm (bkz. number-pair control).
              {
                key: "size",
                control: "number-pair",
                fields: [
                  {
                    key: "width",
                    label: i18n.t("Width"),
                    value: numOrEmpty(imageStructure.width),
                    min: 0,
                    max: 100,
                    suffix: "%",
                    onChange: (next) =>
                      setImageStructure({
                        width: next === "" ? 0 : next,
                        widthUnit: imageStructure.widthUnit || "%",
                      }),
                  },
                  {
                    key: "height",
                    label: i18n.t("Height"),
                    value: imageAspectLocked ? "" : numOrEmpty(imageStructure.height),
                    min: 0,
                    max: 100,
                    disabled: imageAspectLocked,
                    suffix: imageAspectLocked ? i18n.t("Auto") : "%",
                    onChange: (next) =>
                      setImageStructure({
                        height: next === "" ? 0 : next,
                        heightUnit: imageStructure.heightUnit || "%",
                      }),
                  },
                ],
              },
              {
                key: "position",
                control: "number-pair",
                fields: [
                  {
                    key: "x",
                    label: "X",
                    value: posX,
                    min: 0,
                    max: 100,
                    suffix: "%",
                    onChange: (next) =>
                      setImageStructure({
                        x: next === "" ? 0 : `${clamp(next, 0, 100)}%`,
                      }),
                  },
                  {
                    key: "y",
                    label: "Y",
                    value: posY,
                    min: 0,
                    max: 100,
                    suffix: "%",
                    onChange: (next) =>
                      setImageStructure({
                        y: next === "" ? 0 : `${clamp(next, 0, 100)}%`,
                      }),
                  },
                ],
              },
              {
                key: "rotation",
                control: "number",
                label: i18n.t("Rotation"),
                value: rotationVal,
                min: ROTATION_MIN,
                max: ROTATION_MAX,
                suffix: "°",
                onChange: (next) => setStructure("rotation", normalizeRotation(next)),
              },
              {
                key: "url",
                control: "text",
                label: i18n.t("EnrichedPlayer.URL"),
                value: toolbar.state && toolbar.state.url,
                onChange: (next) =>
                  this.props.onToolbarUpdated(box.id, "main", "state", "url", next),
              },
              {
                key: "scale",
                control: "range",
                label: i18n.t("HotspotImages.scale"),
                value: (toolbar.state && toolbar.state.scale) || 1,
                min: 0,
                max: 20,
                step: 0.2,
                onChange: (next) =>
                  this.props.onToolbarUpdated(box.id, "main", "state", "scale", next),
              },
            ]
          : undefined;
      focusedPill = (
        <TopActionPill
          left={this.state.left}
          top={this.state.top}
          actions={[
            {
              key: "change-image",
              Icon: LuUpload,
              label: i18n.t("Replace File"),
              onClick: () => this.props.openFileModal(box.id, "image/*"),
            },
            {
              key: "fit-screen",
              Icon: LuMaximize,
              label: i18n.t("fitToScreen"),
              onClick: () => this.fitBoxToScreen(box, toolbar),
            },
            // Hareketli Görsel'in GIF/WebP'si: kaynak dokümanı kutuya eklenirken
            // `motionSource` olarak yazıldı — kalem onu düzenleyip döngüyü
            // yeniden render eder. Sıradan görsellerde bu not yok, düğme çıkmaz.
            ...(motionEditTarget(toolbar)
              ? [
                  {
                    key: "motion-ai-edit",
                    Icon: LuSparkles,
                    label: i18n.t("SceneVisual.AiEdit", { defaultValue: "AI ile düzenle" }),
                    onClick: () => openMotionAiEdit(box.id),
                  },
                ]
              : []),
            // Görseli Canlandır: png/jpg → doğrudan canlandırma; webp/gif
            // (statik değil) → modal orijinali versions API'sinden çekip oradan
            // yeniden üretime izin verir (bkz. ImageAnimatorModal isVideoSource).
            //
            // Etiket, modalın açılışta seçtiği özelliğin adıyla AYNI i18n
            // anahtarından geliyor ("Animate Image" → "Görseli Canlandır"), yani
            // menüdeki yazı ile popup başlığı ayrışamaz.
            //
            // İkon da modal içindeki "animate" özelliğinin ikonuyla aynı
            // (LuClapperboard, bkz. IMAGE_EDIT_FEATURES) — menüden popup'a
            // görsel süreklilik. animate-icon-clap sınıfı ona klaket "şaklama"
            // hareketi veriyor: sabit bir kareden harekete geçişi anlatıyor.
            //
            // Dışarıdan import edilen animasyonlu/video medya (webp/gif/mp4):
            // versions API'sinde referans (orijinal) görsel yoksa modal boş
            // açılır → buton hep yerinde durur ama tıklanamaz; referans
            // onaylanınca (probe true) etkinleşir. Böylece pill zıplamaz.
            (() => {
              const blocked =
                isNonStaticMediaUrl(toolbar?.state?.url || "") &&
                getCachedHasReferenceImage(toolbar.state.url) !== true;
              return {
                key: "merlin",
                Icon: LuClapperboard,
                label: i18n.t("Animate Image"),
                iconClassName: blocked ? undefined : "animate-icon-clap",
                disabled: blocked,
                disabledHint: i18n.t("AnimateImageNoReference"),
                onClick: () => {
                  if (!blocked) this.openAnimateModal();
                },
              };
            })(),
            ...(toolbar.pluginId === "HotspotImages"
              ? [
                  {
                    key: "click-action",
                    Icon: LuMousePointerClick,
                    label: i18n.t("marks.img_click_action"),
                    onClick: () => this.setState({ showImageClickModal: true }),
                  },
                ]
              : []),
          ]}
          more={imageMore}
        />
      );
    } else if (toolbar.pluginId === "EnrichedPlayer") {
      focusedPill = (
        <TopActionPill
          left={this.state.left}
          top={this.state.top}
          actions={[
            {
              key: "change-video",
              Icon: LuUpload,
              label: i18n.t("Replace File"),
              onClick: () => this.props.openFileModal(box.id, "video/*"),
            },
            canEditInDirector(toolbar.state) && {
              key: "edit-in-director",
              Icon: LuClapperboard,
              label: i18n.t("FileModal.APIProviders.VideoGeneration.Director.EditInDirector"),
              onClick: () => this.props.openFileModal(box.id, "video/*", { importFromBox: true }),
            },
            {
              key: "fit-screen",
              Icon: LuMaximize,
              label: i18n.t("fitToScreen"),
              onClick: () => this.fitBoxToScreen(box, toolbar),
            },
            // Video seçiliyken Aidea Wizard aksiyonu YOK: modal yalnızca salt-görüntü
            // modunda açılabiliyordu (bir video yeniden canlandırılamaz), dolayısıyla
            // hiçbir işe yaramayan bir buton olarak kalıyordu — özellikle dışarıdan
            // yüklenen videolarda (versiyon API'sinde orijinal foto yok) tamamen boş.
          ]}
          more={[
            {
              key: "url",
              control: "text",
              label: i18n.t("EnrichedPlayer.URL"),
              value: toolbar.state && toolbar.state.url,
              onChange: (next) => this.props.onToolbarUpdated(box.id, "main", "state", "url", next),
            },
            // Ses aç/kapa — kontrol butonları gizliyken de sese müdahale
            // edilebilsin. Mevcut `volume` state'ine bağlı (Visor da onu okur);
            // alttaki ses slider'ı yerinde kalır.
            {
              key: "sound",
              label: i18n.t("EnrichedPlayer.Sound"),
              control: "toggle",
              value: !(toolbar.state && toolbar.state.volume === 0),
              onChange: (next) =>
                this.props.onToolbarUpdated(box.id, "main", "state", "volume", next ? 1 : 0),
            },
            {
              key: "controls",
              label: i18n.t("EnrichedPlayer.Show_controls"),
              control: "toggle",
              value: toolbar.state && toolbar.state.controls,
              onChange: (next) =>
                this.props.onToolbarUpdated(box.id, "main", "state", "controls", next),
            },
            {
              key: "autoPlay",
              label: i18n.t("EnrichedPlayer.AutoPlay"),
              control: "toggle",
              value: toolbar.state && toolbar.state.autoPlay,
              onChange: (next) =>
                this.props.onToolbarUpdated(box.id, "main", "state", "autoPlay", next),
            },
            {
              key: "loop",
              label: i18n.t("EnrichedPlayer.Loop"),
              control: "toggle",
              value: toolbar.state && toolbar.state.loop,
              onChange: (next) =>
                this.props.onToolbarUpdated(box.id, "main", "state", "loop", next),
            },
          ]}
        />
      );
    } else if (toolbar.pluginId === "InteractiveItem") {
      // Üretilen interaktif aktivite. Görsel kutusunun pill'iyle aynı mantık:
      // kutunun üstünde, amaç başına bir düğme.
      //
      // İki ayrı düzenleme yolu var ve farkları kasıtlı:
      //   • "Düzenle"      → şemadan çizilen form. VERİYİ değiştirir (kart
      //                      yazısı, cevap anahtarı, satır ekle/sil). Anında,
      //                      kredisiz, modelsiz.
      //   • "AI ile düzenle" → prompt. KODU da değiştirebilir ("daha renkli
      //                      yap", "tıklamayla olsun"). Ücretli, dakikalar.
      // Bir harf hatası için ikincisine gitmek para ve zaman kaybı olurdu, o
      // yüzden ikisi de duruyor.
      //
      // İletişim CustomEvent ile: pill canvas'ın tepesinde ayrı bir portal'da
      // yaşıyor, ekranları açan state ise kutunun kendisinde.
      const fire = (name) => {
        try {
          window.dispatchEvent(new CustomEvent(name, { detail: { boxId: box.id } }));
        } catch (_) {
          const ev = document.createEvent("CustomEvent");
          ev.initCustomEvent(name, true, true, { boxId: box.id });
          window.dispatchEvent(ev);
        }
      };
      focusedPill = (
        <TopActionPill
          left={this.state.left}
          top={this.state.top}
          actions={[
            {
              key: "interactive-ai-edit",
              Icon: LuSparkles,
              label: i18n.t("InteractiveItem.AiEdit", { defaultValue: "AI ile düzenle" }),
              onClick: () => fire("aidea:interactive-ai-edit"),
            },
            {
              key: "interactive-edit",
              Icon: LuPen,
              label: i18n.t("InteractiveItem.Edit", { defaultValue: "Düzenle" }),
              onClick: () => fire("aidea:interactive-edit"),
            },
            {
              key: "fit-screen",
              Icon: LuMaximize,
              label: i18n.t("fitToScreen"),
              onClick: () => this.fitBoxToScreen(box, toolbar),
            },
          ]}
        />
      );
    } else if (toolbar.pluginId === "MotionScene" || toolbar.pluginId === "Scene3D") {
      // Üretilen HTML kutuları (hareketli görsel / 3B obje). Konum/boyut
      // kutunun kendisinde; buradaki düğme "tam ekran yap"ı tek tıkla veriyor
      // (görsel ve video kutularındaki ile aynı davranış).
      //
      // Hareketli görselde bir de kalem var: "AI ile düzenle" — bir cümle,
      // model sahnenin kodunu değiştirir (interaktifteki ile aynı pencere).
      // 3B objede yok: onun düzenleme yolu henüz yazılmadı.
      focusedPill = (
        <TopActionPill
          left={this.state.left}
          top={this.state.top}
          actions={[
            ...(motionEditTarget(toolbar)
              ? [
                  {
                    key: "motion-ai-edit",
                    Icon: LuSparkles,
                    label: i18n.t("SceneVisual.AiEdit", { defaultValue: "AI ile düzenle" }),
                    onClick: () => openMotionAiEdit(box.id),
                  },
                ]
              : []),
            // "MP4 / WebP'ye çevir": motion olduğu gibi, kendi süresiyle
            // çevrilip kütüphaneden eklenmiş gibi sahneye girer.
            ...(toolbar.pluginId === "MotionScene" && toolbar.state && toolbar.state.htmlUrl
              ? [
                  {
                    key: "motion-to-video",
                    Icon: LuFilm,
                    label: i18n.t("SceneVisual.ToVideo", { defaultValue: "MP4 / WebP'ye çevir" }),
                    onClick: () => openMotionToVideo(box.id),
                  },
                ]
              : []),
            {
              key: "fit-screen",
              Icon: LuMaximize,
              label: i18n.t("fitToScreen"),
              onClick: () => this.fitBoxToScreen(box, toolbar),
            },
          ]}
        />
      );
    } else if (toolbar.pluginId === "AtomicBoxPlugin") {
      // Smart elements (Heading/Eyebrow/Footer/Quote/…) — quick whole-box
      // size/alignment without entering edit mode, same as BasicText's quick
      // actions below. AtomicBoxPlugin scales via ThemeBridge's own
      // `fontScale` (%) prop — a separate render path from the plain-text one
      // below, so it keeps that mechanism. (Legacy RichText boxes now take
      // the BasicText pill branch below — the plugin is a BasicText alias.)
      // No font-family control here: smart elements get their typography from
      // ThemeBridge, not a manual per-box override.
      // fontScale is a unitless multiplier (0.4-2.0) — shown/edited here as a
      // percentage (100 = un-scaled), same convention EditorBox.jsx already
      // renders it with (`Math.round(fontScale * 100) + "%"`).
      const setFontScalePercent = (percent) => {
        const next = Math.min(2.0, Math.max(0.4, parseFloat((percent / 100).toFixed(2))));
        this.props.onToolbarUpdated(box.id, "main", "state", "fontScale", next);
      };
      // State key only: EditorBox turns it into the boxTextAlign-* class.
      // NOT applyTextFormatValue — that restyles __text as HTML, and here
      // __text is URI-encoded JSON, so it corrupted the element (box vanished,
      // timeline showed raw JSON).
      const setTextAlign = (align) => {
        this.props.onToolbarUpdated(box.id, "main", "state", "textAlign", align);
      };
      focusedPill = (
        <TopActionPill
          left={this.state.left}
          top={this.state.top}
          actions={[
            {
              // Exact size visible/editable directly on the bar, same as the
              // BasicText pill's fontSize stepper below.
              key: "fontScale",
              control: "stepper",
              label: i18n.t("BasicText.font_size"),
              value: Math.round((toolbar.state.fontScale || 1) * 100),
              base: 100,
              min: 40,
              max: 200,
              step: 15,
              onChange: (value) => setFontScalePercent(value),
            },
            {
              key: "align-left",
              Icon: LuAlignLeft,
              label: i18n.t("messages.align_left"),
              onClick: () => setTextAlign("left"),
            },
            {
              key: "align-center",
              Icon: LuAlignCenter,
              label: i18n.t("messages.align_center"),
              onClick: () => setTextAlign("center"),
            },
            {
              key: "align-right",
              Icon: LuAlignRight,
              label: i18n.t("messages.align_right"),
              onClick: () => setTextAlign("right"),
            },
          ]}
        />
      );
    } else if (
      (toolbar.pluginId === "BasicText" || toolbar.pluginId === "RichText") &&
      !toolbar.showTextEditor
    ) {
      // BasicText's whole-box formatting pill (legacy RichText boxes share it —
      // the plugin is a BasicText alias). Every control here is a direct
      // box-state property applied uniformly to the whole box — NOT tied to the
      // CKEditor selection or text-edit mode, so it takes effect immediately
      // with no "enter edit mode, then Kaydet" step in between. While the full
      // CKEditor is open (showTextEditor — right rail "Metni Düzenle" or
      // double-click) the pill hides: CKEditor's own floating toolbar owns
      // per-selection formatting and the two would overlap on screen.
      const setTextState = (key, value) => {
        this.applyTextFormatValue(box.id, toolbar.state.__text, key, value);
      };
      focusedPill = (
        <TopActionPill
          left={this.state.left}
          top={this.state.top}
          actions={[
            {
              key: "fontFamily",
              control: "font-picker",
              label: i18n.t("BasicText.font_family"),
              value: toolbar.state.textFontFamily || "",
              anchorBoxId: box.id,
              onChange: (value) => setTextState("textFontFamily", value),
              onPreview: (value) => this.previewFontFamily(box.id, value),
            },
            {
              // Moved here from the gear "more" popover so the exact size is
              // visible/editable directly on the bar instead of a click away.
              key: "fontSize",
              control: "stepper",
              label: i18n.t("BasicText.font_size"),
              value:
                toolbar.state.textFontSize ||
                deriveTextFormatCached(toolbar.state.__text).textFontSize ||
                "",
              base: 16,
              min: 6,
              max: 200,
              step: 2,
              onChange: (value) => setTextState("textFontSize", value),
            },
            {
              key: "bold",
              Icon: LuBold,
              label: i18n.t("BasicText.bold"),
              active: !!toolbar.state.bold,
              onClick: () => setTextState("bold", !toolbar.state.bold),
            },
            {
              key: "italic",
              Icon: LuItalic,
              label: i18n.t("BasicText.italic"),
              active: !!toolbar.state.italic,
              onClick: () => setTextState("italic", !toolbar.state.italic),
            },
            {
              key: "underline",
              Icon: LuUnderline,
              label: i18n.t("BasicText.underline"),
              active: !!toolbar.state.underline,
              onClick: () => setTextState("underline", !toolbar.state.underline),
            },
            {
              key: "align-left",
              Icon: LuAlignLeft,
              label: i18n.t("messages.align_left"),
              active: toolbar.state.textAlign === "left",
              onClick: () => setTextState("textAlign", "left"),
            },
            {
              key: "align-center",
              Icon: LuAlignCenter,
              label: i18n.t("messages.align_center"),
              active: toolbar.state.textAlign === "center",
              onClick: () => setTextState("textAlign", "center"),
            },
            {
              key: "align-right",
              Icon: LuAlignRight,
              label: i18n.t("messages.align_right"),
              active: toolbar.state.textAlign === "right",
              onClick: () => setTextState("textAlign", "right"),
            },
            // PER-SELECTION rich formatting lives in the full CKEditor, opened
            // from the right rail's "Metni Düzenle" (EditorApp elementActions) —
            // same entry point as RichText. No extra button here.
          ]}
          more={[
            {
              key: "textColor",
              control: "color",
              label: i18n.t("BasicText.text_color"),
              value: toolbar.state.textColor || "#000000",
              onChange: (value) => setTextState("textColor", value),
            },
            {
              key: "highlightColor",
              control: "color",
              label: i18n.t("BasicText.highlight_color"),
              value: toolbar.state.highlightColor || "rgba(255,255,255,0)",
              onChange: (value) => setTextState("highlightColor", value),
            },
          ]}
        />
      );
    }

    const legacy = portalRoot ? ReactDOM.createPortal(toolbar_el, portalRoot) : toolbar_el;
    return focusedPill ? (
      <>
        {legacy}
        {focusedPill}
      </>
    ) : (
      legacy
    );
  }

  onLipsyncModalToggle() {
    this.setState({ showLipsyncModal: !this.state.showLipsyncModal });
  }

  onLipsyncComplete(newVideoUrl) {
    // Update the video URL in the plugin toolbar state
    if (this.props.onToolbarUpdated && this.props.pluginToolbar) {
      this.props.onToolbarUpdated(this.props.pluginToolbar.id, "main", "state", "url", newVideoUrl);
    }

    // Note: Modal is closed from within the LipsyncModal component
    // after successful completion, so we don't need to close it here
  }

  getSceneAudios() {
    const chosenIndex = this.props.store?.getState()?.undoGroup?.present?.navItemSelected;

    const sceneAudios = this.props.store?.getState()?.undoGroup?.present?.soundList?.[chosenIndex];
    if (!sceneAudios || sceneAudios.length === 0) {
      return [];
    }

    return sceneAudios;
  }

  // "Görseli Canlandır" pill: open the wizard ON animate. Without an explicit
  // feature the modal restores the box's last persisted job (e.g. an unaccepted
  // "Çözünürlüğü Artır") and the animate button would open that form instead.
  openAnimateModal() {
    this.setState({
      showImageAnimatorModal: true,
      imageAnimatorInitial: { operation: "animate" },
    });
  }

  // "Görseli Düzenle" in the animation popup: close this popup and let EditorApp
  // run the fix-the-still → animate-again round trip (it owns AreaOpsModal and
  // reopens the animation popup afterwards).
  onEditAnimationSource({ sourceUrl, settings }) {
    if (this.state.showImageAnimatorModal) this.onImageAnimatorModalToggle();
    window.dispatchEvent(
      new CustomEvent("aidea:editAnimationSource", {
        detail: { boxId: this.props.box?.id, sourceUrl, settings },
      })
    );
  }

  onImageAnimatorModalToggle() {
    const willOpen = !this.state.showImageAnimatorModal;
    this.setState({
      showImageAnimatorModal: willOpen,
      ...(willOpen ? {} : { imageAnimatorInitial: null }),
    });
    // Un-dock the chat when the editor closes (it was docked on agent-open).
    if (!willOpen) {
      try {
        setPopupDocked(false);
      } catch {
        /* gateway not loaded — non-fatal */
      }
    }
  }

  // DEPRECATED: Remove this prop
  onAcceptAnimation(animationData) {
    // Prefer the boxId the modal pinned when it opened (animationData.boxId).
    // Falls back to this.props.box?.id for backwards compat. Using the
    // pinned id avoids a stale-state bug: if the user selected a different
    // box while the animate job was running (which can take minutes), the
    // approve click would otherwise overwrite the wrong box's URL.
    const targetBoxId = animationData?.boxId || this.props.box?.id;
    if (!targetBoxId) {
      console.error(
        "[EditorShortcuts] Approve animation: no target box id (modal didn't pin one and no box is currently selected). Cannot apply result.",
        animationData
      );
      return;
    }
    if (!this.props.onToolbarUpdated) {
      console.error(
        "[EditorShortcuts] Approve animation: onToolbarUpdated prop is missing — cannot apply result to box",
        targetBoxId
      );
      return;
    }

    const url = animationData?.url;
    const present = this.props.store && this.props.store.getState()?.undoGroup?.present;
    const decision = applyAnimationResult({
      boxId: targetBoxId,
      url,
      boxes: present?.boxesById,
      pluginToolbars: present?.pluginToolbarsById,
      containedViewSelected: present?.containedViewSelected,
      containedViews: present?.containedViewsById,
      navItems: present?.navItemsById,
      navItemSelected: present?.navItemSelected,
    });

    if (decision.kind === "boxSwap" && this.props.store) {
      const IdealStudio = require("../../../../core/editor/main").default;
      const { createBox } = require("../../../../common/common_tools");
      const { addBoxThunk, changeBoxLayer } = require("../../../../common/actions.es6");

      if (IdealStudio.Plugins.get(decision.newBox.name)) {
        // decision.newBox.name is "EnrichedPlayer" for the forward
        // (image→video) swap and "HotspotImages" for the reverse
        // (video→image) swap — applyAnimationResult decides which, this call
        // site just instantiates whichever it picked.
        // Timeline satır sırası / z-order kaynağı navItemsById[parent].boxes
        // (veya contained view'sa containedViewsById[parent].boxes) — swap
        // öncesindeki sırayı yakalayıp aşağıda eski kutunun index'ini yeni
        // kutuya devrediyoruz (aksi halde ADD_BOX/DELETE_BOX videoyu her zaman
        // sıranın sonuna zıplatır).
        const srcParentIsCv = isContainedView(decision.parent);
        const parentBoxesBefore = srcParentIsCv
          ? present.containedViewsById?.[decision.parent]?.boxes
          : present.navItemsById?.[decision.parent]?.boxes;

        createBox(
          decision.newBox,
          decision.newBox.name,
          decision.inASlide,
          (...args) => this.props.store.dispatch(addBoxThunk(...args)),
          present.boxesById
        );
        if (this.props.onBoxDeleted) {
          this.props.onBoxDeleted(
            decision.oldBoxId,
            decision.parent,
            decision.container,
            decision.page
          );
        }
        if (Array.isArray(parentBoxesBefore)) {
          const restoredOrder = parentBoxesBefore.map((id) =>
            id === targetBoxId ? decision.newBoxId : id
          );
          this.props.store.dispatch(
            changeBoxLayer(decision.newBoxId, decision.parent, 0, "reorder", restoredOrder)
          );
        }
        return;
      }
    }

    this.props.onToolbarUpdated(targetBoxId, "main", "state", "url", url);
  }

  // handleChange(e) {
  //     this.setState({ urlValue: e.target.value });
  // }
  // Resize the box to fill the scene (100% × 100%) and pin to the top-left —
  // shared by the image + video focused pills (same action as the right-panel).
  fitBoxToScreen(box, toolbar) {
    this.props.onBoxResized(toolbar.id, {
      width: "100",
      widthUnit: "%",
      height: "100",
      heightUnit: "%",
    });
    this.props.onBoxMoved(box.id, "0%", "0%", "absolute", box.parent, box.container);
  }

  resizeAndSetState(fromUpdate, newProps) {
    let { width, top, left } = this.resize(fromUpdate, newProps);
    this.setState({ left: left, top: top, width: width });
  }
  resize(fromUpdate, newProps) {
    const props = fromUpdate === "fromUpdate" ? newProps : this.props;
    // Measure against the VISIBLE pill layer — #editorBoxIconsRoot is display:none
    // (zero rect), which would place the pill at the viewport origin.
    const root =
      document.getElementById("topPillRoot") ||
      document.getElementById("editorBoxIconsRoot") ||
      document.getElementById("canvasArea");
    if (!root) return { left: 0, top: 0, width: 0 };

    const rootRect = root.getBoundingClientRect();
    const TOOLBAR_H = 44;
    const toolbarW = this.innerContainerRef.current?.offsetWidth || 0;

    // Use the selected box element as anchor
    const boxEl = props?.box?.id ? findBox(props.box.id) : null;
    if (boxEl) {
      const boxRect = boxEl.getBoundingClientRect();
      const top = Math.max(4, boxRect.top - rootRect.top - TOOLBAR_H - 4);
      const left = boxRect.right - rootRect.left - Math.max(toolbarW, 8) - 8;
      return { left, top, width: 0 };
    }

    // Fallback: above airlayer
    const airlayerId = props?.isContained ? "airlayer_cv" : "airlayer";
    const airlayer = document.getElementById(airlayerId);
    if (!airlayer) return { left: 0, top: 0, width: 0 };
    const airRect = airlayer.getBoundingClientRect();
    return {
      left: airRect.right - rootRect.left - Math.max(toolbarW, 8) - 8,
      top: Math.max(4, airRect.top - rootRect.top - TOOLBAR_H - 4),
      width: 0,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      if (nextProps.box) {
        this.setState({ displayArrows: 0, alignmentButtonsAbove: false });
        this.resizeAndSetState("fromUpdate", nextProps);
        // this.setState({ left: left, top: top, width: width });
      }
    }

    if (
      this.props.fileModalResult &&
      nextProps.fileModalResult &&
      nextProps.box &&
      this.props.box &&
      nextProps.box.id === nextProps.fileModalResult.id &&
      nextProps.fileModalResult.value &&
      /* (this.state.open || this.props.boxCreated) &&*/ this.props.fileModalResult.value !==
        nextProps.fileModalResult.value
    ) {
      this.props.onToolbarUpdated(
        nextProps.box.id,
        "main",
        "state",
        this.state.callbackKey || "url",
        nextProps.fileModalResult.value
      );
      this.setState({ open: false, callbackKey: undefined });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    let { width, top, left } = this.resize();
    if (this.state.width !== width || this.state.top !== top || this.state.left !== left) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ left: left, top: top, width: width });
    }
    // Keep the selected-element global in sync when the selection or its image
    // URL changes (e.g. user picks a different box, or edits the image).
    const prevId = prevProps.box ? prevProps.box.id : undefined;
    const curId = this.props.box ? this.props.box.id : undefined;
    const prevUrl = prevProps.pluginToolbar?.state?.url;
    const curUrl = this.props.pluginToolbar?.state?.url;
    if (prevId !== curId || prevUrl !== curUrl) {
      this.publishSelectedElement();
      this.probeReferenceImage();
    }
  }

  // Animasyonlu/video görsel kaynağında (webp/gif/mp4) "Görseli Canlandır"
  // yalnız versions API'sinde bir referans (orijinal statik) görsel varsa
  // gösterilir. Sonuç gelince yeniden render tetikle.
  probeReferenceImage() {
    const tb = this.props.pluginToolbar;
    const url = tb?.state?.url || "";
    if (tb?.pluginId !== "HotspotImages" || !isNonStaticMediaUrl(url)) return;
    if (getCachedHasReferenceImage(url) !== undefined) return;
    resolveHasReferenceImage(url, fetchHasReferenceImage).then(() => {
      if (this._unmounted) return;
      if ((this.props.pluginToolbar?.state?.url || "") !== url) return;
      this.setState((s) => ({ refImageProbeTick: s.refImageProbeTick + 1 }));
    });
  }

  componentWillUpdate(nextProps) {
    if (nextProps !== this.props) {
      if (nextProps.box) {
        // this.resize("fromUpdate", nextProps);
        // Removes pointer events allowance when box is changed
        if (!this.props.box || nextProps.box.id !== this.props.box.id) {
          let boxEl = findBox(this.props.box ? this.props.box.id : "");
          if (boxEl) {
            if (this.props.pointerEventsCallback) {
              this.props.pointerEventsCallback("disableAll", this.props.pluginToolbar);
            }
            boxEl.classList.remove("pointerEventsEnabled");
          }
          let pebutton = document.getElementById("pebutton");
          if (pebutton) {
            pebutton.classList.remove("dtbSelected");
          }
        }
      }
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.resizeAndSetState);
    window.addEventListener("aidea:openImageAnimator", this.onOpenImageAnimatorRequest);
    this.publishSelectedElement();
    this.probeReferenceImage();
    if (this.props && this.props.box) {
      let boxObj = findBox(this.props.box.id);
      if (boxObj) {
        boxObj.addEventListener("resize", this.resizeAndSetState);
      }
    }
  }

  componentWillUnmount() {
    this._unmounted = true;
    let boxEl = findBox(this.props.box ? this.props.box.id : "");
    if (boxEl) {
      let bool = boxEl.classList.contains("pointerEventsEnabled");
      if (this.props.pointerEventsCallback) {
        this.props.pointerEventsCallback("disableAll", this.props.pluginToolbar);
      }
      boxEl.classList.remove("pointerEventsEnabled");
    }

    window.removeEventListener("resize", this.resizeAndSetState);
    window.removeEventListener("aidea:openImageAnimator", this.onOpenImageAnimatorRequest);
    // Clear the selected-element global — nothing is selected once this toolbar
    // unmounts (deselect / box removed).
    if (typeof window !== "undefined") {
      window.__aideaSelectedElement = undefined;
    }
    if (this.props && this.props.box) {
      let boxObj = findBox(this.props.box.id);
      if (boxObj) {
        boxObj.removeEventListener("resize", this.resizeAndSetState);
      }
    }
  }

  getElementHeightPercent(elementid) {
    let elementt = document.getElementById(elementid);
    let divHeight = elementt.style.height.replace("%", "");
    if (elementt.style.height === "auto") {
      let maincontentHeight = 0;
      let maincontentdiv = document.getElementById("maincontent");
      if (maincontentdiv.offsetHeight) {
        maincontentHeight = maincontentdiv.offsetHeight;
      } else if (maincontentdiv.style.pixelHeight) {
        maincontentHeight = maincontentdiv.style.pixelHeight;
      }

      if (elementt.offsetHeight) {
        divHeight = elementt.offsetHeight;
      } else if (elementt.style.pixelHeight) {
        divHeight = elementt.style.pixelHeight;
      }
      divHeight = (divHeight / maincontentHeight) * 100.0;
    }
    return divHeight;
  }
}

EditorShortcuts.propTypes = {
  store: PropTypes.object.isRequired,
  /**
   * Selected box
   */
  box: PropTypes.any,
  /**
   * Selected contained view (by ID)
   */
  containedViewSelected: PropTypes.any,
  /**
   * Check if component is rendered from contained view
   */
  isContained: PropTypes.bool,
  /**
   * Callback for toggling CKEditor
   */
  onTextEditorToggled: PropTypes.func.isRequired,
  /**
   * Callback for toggling creation mark overlay
   */
  onMarkCreatorToggled: PropTypes.func.isRequired,
  /**
   * Callback for deleting a box
   */
  onBoxDeleted: PropTypes.func.isRequired,
  /**
   * Callback for resizing a box
   */
  onBoxResized: PropTypes.func.isRequired,
  /**
   *  Callback for enabling pointer events
   */
  pointerEventsCallback: PropTypes.func,
  /**
   * Current selected view (by ID)
   */
  navItemSelected: PropTypes.any,
  /**
   * Object containing all the plugins' toolbars
   */
  pluginToolbar: PropTypes.object,
  /**
   * Function that opens a configuration modal
   */
  openConfigModal: PropTypes.func.isRequired,
  /**
   * Function for updating the box's toolbar
   */
  onToolbarUpdated: PropTypes.func,
  /**
   * Last files uploaded to server or searched in modal
   */
  fileModalResult: PropTypes.object,
  /**
   * Function that opens the file search modal
   */
  openFileModal: PropTypes.func.isRequired,
  /**
   * Function for uploading files
   */
  uploadFunction: PropTypes.func,
  /**
   * Current timeline time in seconds
   */
  base: PropTypes.object,
};
